const templateType = document.body.dataset.templateType;
import { Collapse, Modal } from 'bootstrap';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import 'lazysizes';
import $ from 'jquery';

// Call cleanupDeviceCheck to remove listeners
// Example: cleanupDeviceCheck();
import InitDeviceCheck from './app/initializers/init-device-check';
const cleanupDeviceCheck = InitDeviceCheck();

import MXShop from './core/mx-shop';

// import InitializeMenu from './app/components/initialize-menu';
// import BlogFilter from './app/components/blog-filter';
import BlogCarousel from './app/components/blog-carousel';
import BlogGallery from './app/components/blog-gallery';
import BlogIntroVideo from './app/components/blog-intro-video';
import CartPopup from './app/components/cart-popup';
import Faqs from './app/components/faqs';
import SidebarFilter from './app/components/sidebar-filter';
import VideoController from './app/components/video-controller';
import ArticlesSlider from './app/components/articles-slider';
import CollectionSlider from './app/components/collection-slider';
import FeaturedProductsSlider from './app/components/featured-products-slider';
import Gallery from './app/components/gallery';
import IntroSlider from './app/components/intro-slider';
import Panel from './app/components/panel';
import ReviewCallout from './app/components/review-callout';
import TextCallout from './app/components/text-callout';
import SingleProduct from './app/components/single-product';
import RelatedArticles from './app/components/related-articles';
import RelatedRecipes from './app/components/related-recipes';
import PinSidebarFilter from './app/components/pin-sidebar-filter';

/** 2024 Updates **/
import getTaggedArticlesCount from './utils/get-tagged-articles-count';

import AccountAddresses from './app/components/account-addresses';
import BasicSlider from './app/components/basic-slider';
import ArticleGrid from './app/components/article-grid';
import ArticleRecipes from './app/sections/article-recipes';
import ArticleSlider from './app/sections/article-slider';
import CircleHeader from './app/components/circle-header';
import CollectionCarousel from './app/sections/collection-carousel';
import FeaturedArticles from './app/sections/featured-articles';
import HeroMain from './app/sections/hero-main';
import InitHeader from './app/initializers/init-header';
import Marquee from './app/sections/marquee';
import ProductSlider from './app/sections/product-slider';
import ShopProductsGrid from './app/sections/shop-products-grid';
// import MobileMenu from './app/components/kc-mobile-menu';
/** 2024 Updates **/

MXShop({
  cartAware: true,
  cartAlert: false,
  hasCartDrawer: false,
});

gsap.registerPlugin(ScrollTrigger);

// InitializeMenu();
// BlogFilter();
BlogCarousel();
BlogGallery();
BlogIntroVideo();
CartPopup();
Faqs();
SidebarFilter();
VideoController();
ArticlesSlider();
CollectionSlider();
FeaturedProductsSlider();
// Gallery(); // not used
IntroSlider();
// Panel(); // not used
ReviewCallout();
TextCallout();
SingleProduct();
RelatedArticles();
RelatedRecipes();

/** 2024 Updates **/
AccountAddresses();
ArticleGrid();
ArticleRecipes();
ArticleSlider();
BasicSlider();
CircleHeader();
CollectionCarousel();
FeaturedArticles();
HeroMain();
InitHeader();
Marquee();
ProductSlider();
ShopProductsGrid();

// Reload on shopify section changes
document.addEventListener( 'shopify:section:load', function( evt ){
  FeaturedArticles();
  // Marquee();  
  CollectionCarousel();
  HeroMain();
})

/** 2024 Updates **/
window.addEventListener('load', (e) => {
  document.documentElement.classList.add('ready-state-loaded');
  if (
    templateType === 'collection' ||
    templateType === 'blog.recipes'
  ) {
    PinSidebarFilter();
  }

  getTaggedArticlesCount();
})

window.addEventListener("DOMContentLoaded", (event) => {
  const moveModalsToBody = () => {
    document.querySelectorAll('.modal--read-more').forEach(modal => {
      document.body.appendChild(modal);
    });
  }
  moveModalsToBody();

  const justifiedHeaderLines = document.querySelectorAll('.justified-header .line');
  justifiedHeaderLines.forEach(line => {
    const lineText = line.querySelector('.line-text');
    const letters = lineText.textContent.split('');
    for (let letter of letters) {
      if (letter === '\n') {
        continue;
      }
      const letterSpan = document.createElement('span');
      if (letter === ' ') {
        letter = '&nbsp;';
        letterSpan.classList.add('space');
      }
      letterSpan.classList.add('ch');
      letterSpan.setAttribute('style', lineText.getAttribute('style'));
      letterSpan.setAttribute('aria-hidden', 'true');
      letterSpan.innerHTML = letter;
      line.appendChild(letterSpan);
    }
    lineText.remove();
  })

  const updateHeights = () => {
    const hextomHeight = document.querySelector('#fsb_placeholder').offsetHeight;
    document.documentElement.style.setProperty('--hextom-height', `${hextomHeight}px`);
    const headerHeight = document.querySelector('.shopify-section.header__wrapper').offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--full-header-height', `${headerHeight + hextomHeight}px`);
  }

  updateHeights();
  window.addEventListener('resize', updateHeights);
  const resizeObserver = new ResizeObserver(entries => updateHeights())

  const hextom = document.querySelector('#fsb_placeholder');
  resizeObserver.observe(hextom);

  const headerResizeObserver = new ResizeObserver(entries => updateHeights())
  const header = document.querySelector('.shopify-section.header__wrapper');
  headerResizeObserver.observe(header);

  document.querySelectorAll("ol[start]").forEach(ol => {
    const start = parseInt(ol.getAttribute("start"), 10);
    ol.style.setProperty('--start', start - 1);
  });
})